//do nothing on load, cshtml takes care of onload events

//if the user has allowed their location post-load
    //if they did, find the nearest location and er time via ajax call, update the table
    //if they did not, do nothing

//if the user has chaanged their loaction post load
    //update the display, update the table

var geoLocationOptions = {
    enableHighAccuracy: false,
    timeout: 3000,
    maximumAge: 0
};

//check their current geolocation permission state
navigator.permissions.query({ name: 'geolocation' }).then(function (permissionStatus) {
    //get current permission status on load
    if (permissionStatus.state == "denied") {
        $('.er-wait-blocked-container').show();
        /*
        //if they dont have a cookie from a previous location ID check
        if (getCookie('DEFAULT_LOCATION_ID') == null) {
            $('.er-wait-blocked-container').show();
        }
        else {
            $('.er-wait-shared-container').show();
        }
        */
    }
    else if (permissionStatus.state == "granted") {
        $('.er-wait-shared-container').show();
    }
    else {
        $('.er-wait-prompt-container').show();
    }

    /* this violates UX guidelines by asking on load, we dont want that */
    //navigator.geolocation.getCurrentPosition(onLocationFetchSuccess, onLocationFetchFailure);

    // we cannot use this approach, as there is a bug in firefox that does not let this work
    //ref: https://stackoverflow.com/questions/55127053/navigator-permissions-query-geolocation-onchange-not-working-in-firefox
    /*
    permissionStatus.onchange = function () {
        if (permissionStatus.state == "granted") {
            console.log("here onchange gramted");
        }

        if (permissionStatus.state === 'denied') {
            console.log("here5 onchange denied");
        }
    }
    */
})

function updatedUserGeoFromBrowser(position) {
    var lat = position.coords.latitude;
    var long = position.coords.longitude;
    setGeoCookie(position);

    var usergeoupdateurl = '/api/sitecore/ERWait/UpdateUserGeoFromBrowser?lat=' + lat + '&lon=' + long;

    //get the ID of the nearest location
    $.ajax({
        url: usergeoupdateurl,
        cache: false,
        method: 'GET',
        success: function (data) {
            var clientid = data;
            getNearestLocationData(clientid);
            updateLocationChangeModal(clientid);
        },
        error: function (data) {
            $('.er-wait-blocked-container').show();
            $('.er-wait-prompt-container').hide();
            $('.er-wait-shared-container').hide();
            $('.er-wait-error-container').hide();
        }
    });
}

function getLocation() {
    //they allowed their location
    if (navigator.geolocation) {
        //navigator.geolocation.getCurrentPosition(showPosition, showError);

        const onLocationFetchSuccess = (position) => {
            updatedUserGeoFromBrowser(position);
        };

        const onLocationFetchFailure = (error = {}) => {
            // Error code 1 corresponds to user denying/blocking the location permission

            if (error.code === 1) {
                //they are blocking their location
                $('.er-wait-blocked-container').show();
                $('.er-wait-prompt-container').hide();
                $('.er-wait-shared-container').hide();
                $('.er-wait-error-container').hide();
            }
        };

        navigator.geolocation.getCurrentPosition(onLocationFetchSuccess, onLocationFetchFailure);
    }
    else {
        console.log("The browser does not support geolocation");
    }
}

function geoLocationError(error) {
    console.log("geolocationerror: (" + error.code + ") " + error.message);
}

function getNearestLocationData(clientidval) {
    var clientID = clientidval;
    var updateurl = '/api/sitecore/ERWait/GetNearestLocationData?clientID=' + clientID;

    $.ajax({
        url: updateurl,
        cache: false,
        method: 'GET',
        success: function (data) {
            //fill in the data
            $('[data-er-wait-time]').text(data.er_wait.CV_ED_Wait);
            $('[data-er-wait-name]').text(data.location.LocationName);

            //show the data
            $('.er-wait-prompt-container').hide();
            $('.er-wait-shared-container').show();
            $('.er-wait-blocked-container').hide();
            $('.er-wait-error-container').hide();
        },
        error: function (data) {
            $('.er-wait-prompt-container').hide();
            $('.er-wait-shared-container').hide();
            $('.er-wait-error-container').show();
            $('.er-wait-blocked-container').hide();
        }
    });
};

if ($('.er-wait').attr('data-preloaded') === undefined) {
    //getLocation(); 
}

function updateLocationChangeModal(clientID) {
    $('.change-location-header-modal').modal('hide');

    var optionslisturl = '/api/sitecore/ERWait/HeaderUpdatedListOptions?clientID=' + clientID;

    $.ajax({
        url: optionslisturl,
        cache: false,
        method: 'GET',
        success: function (data) {
            $('.change-location-header-modal div.modal-body').html(data);
        }, error: function (data) {
            $('.er-wait-error-container').show();
            $('.er-wait-prompt-container').hide();
            $('.er-wait-shared-container').hide();
            $('.er-wait-blocked-container').hide();
        }
    });

    //
}

$('a[data-change-location]').click(function (event) {
    event.preventDefault();
    $(this).closest('.sc-component').find('.change-location-header-modal').modal('show');
});

$(document).on('click', '[rel=change-default-location]', function () {
    var clientID = $(this).val();
    getNearestLocationData(clientID); //update the er wait time and location name
    updateLocationChangeModal(clientID)
    //update location list
});

$(document).on('click', '[rel=gps-change-default-location]', function () {
    getLocation();
}); 

window.setGeoCookie = function setGeoCookie(position) {
    var cookie_val = position.coords.latitude + "---" + position.coords.longitude;
    var now = new Date();
    now.setTime(now.getTime() + 1 * 3600 * 1000);
    document.cookie = "geolocationCoords=" + escape(cookie_val) + "; expires=" + now.toUTCString() + "; path=/";
}
